import { memo, useEffect } from "react";
import "../../../node_modules/bootstrap/dist/css/bootstrap.min.css";
import ".././inner.css";
import { LazyLoadImage } from "react-lazy-load-image-component";

function MobilityExercises() {
  useEffect(() => {
    document.title =
      "Strengthening and Mobility Exercises | Viksha Health Care";
    const newMetaDescription =
      "Strengthening and mobility exercises guidance at Viksha Health Care. Improve stability, flexibility, and movement with a safe, progressive plan.";
    const metaTag = document.querySelector('meta[name="description"]');
    if (metaTag) {
      metaTag.setAttribute("content", newMetaDescription);
    }
  }, []);

  return (
    <>
      <h2 style={{ fontSize: "0px" }}>Strengthening and Mobility Exercises</h2>
      <div className="serinfobox">
        <div className="serinfoimg">
          <LazyLoadImage src="/photo/Strengthening-and-Mobility-Exercises.avif" />
        </div>
        <div className="textareaofser">
          <h1>Strengthening and Mobility Exercises</h1>

          <p>
            Strengthening and mobility exercises are essential parts of
            orthopaedic care and rehabilitation. These exercises help restore
            muscle strength, improve joint flexibility, and support safe return
            to daily activities after injury, surgery, or long-term joint
            problems.
          </p>

          <p>
            A well-designed exercise program not only reduces pain and stiffness
            but also helps prevent future injuries by improving overall body
            stability and movement control.
          </p>

          <h5>Benefits of Strengthening Exercises</h5>
          <ul>
            <li>Improves muscle support around joints</li>
            <li>Enhances joint stability and balance</li>
            <li>Reduces strain on injured areas</li>
            <li>Promotes better posture and movement patterns</li>
            <li>Supports long-term joint health</li>
          </ul>

          <h5>Benefits of Mobility Exercises</h5>
          <ul>
            <li>Increases joint flexibility and range of motion</li>
            <li>Reduces stiffness after injury or surgery</li>
            <li>Improves circulation to healing tissues</li>
            <li>Enhances comfort during daily activities</li>
          </ul>

          <h5>Who Needs These Exercises?</h5>
          <ul>
            <li>Patients recovering from fractures or surgeries</li>
            <li>Individuals with arthritis or chronic joint pain</li>
            <li>People with muscle weakness or imbalance</li>
            <li>Those returning to sports or physical activity</li>
            <li>Older adults aiming to maintain mobility and balance</li>
          </ul>

          <h5>Types of Exercises Included</h5>

          <h6>Stretching Exercises</h6>
          <p>
            Gentle stretches help maintain flexibility and reduce muscle
            tightness that can limit movement.
          </p>

          <h6>Strength Training</h6>
          <p>
            Controlled resistance exercises strengthen muscles around joints to
            improve stability and function.
          </p>

          <h6>Balance and Coordination Exercises</h6>
          <p>
            These exercises help improve body control and reduce the risk of
            falls or repeat injuries.
          </p>

          <h6>Functional Movement Training</h6>
          <p>
            Exercises that mimic daily activities help patients safely return to
            routine tasks like walking, climbing stairs, or lifting objects.
          </p>

          <h5>Guidelines for Safe Exercise</h5>
          <ul>
            <li>Start slowly and increase intensity gradually</li>
            <li>Avoid movements that cause sharp pain</li>
            <li>Follow professional guidance for proper technique</li>
            <li>Be consistent with the exercise routine</li>
          </ul>

          <p>
            With regular strengthening and mobility exercises, patients can
            regain confidence in movement, reduce discomfort, and maintain an
            active and healthy lifestyle.
          </p>
        </div>
      </div>
    </>
  );
}

export default memo(MobilityExercises);
